/*
 * サブシステム名：マスタ管理
 * 機能名：配車表マスタ登録
 */
import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'

import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import dolly from '@/rahmen/utils/dolly'

import header from '@/ddv2.library/header'
import message from '@/ddv2.library/messages'
import modals from '@/ddv2.library/modals'

const DdCheckbox = () => import('@/components/DdCheckbox')
const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdDataTable = () => import('@/components/DdDataTable')
const DdDropDown = () => import('@/components/DdDropDown')
const DdEditDialog = () => import('@/components/DdEditDialog')
const DdHaishahyoHimodukeButton = () => import('@/components/DdHaishahyoHimodukeButton')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
const DdNarrowDownTextBox = () => import('@/components/DdNarrowDownTextBox')
const DdNumericBox = () => import('@/components/DdNumericBox')
const DdRowCountBox = () => import('@/components/DdRowCountBox')
const DdSelectItemsPerPage = () => import('@/components/DdSelectItemsPerPage')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdTextBox = () => import('@/components/DdTextBox')

export default {
  name: 'MstHaishahyoEdit',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdCheckbox,
    DdCodeTextBox,
    DdDataTable,
    DdDropDown,
    DdEditDialog,
    DdHaishahyoHimodukeButton,
    DdIconButtonWithTooltip,
    DdNarrowDownTextBox,
    DdNumericBox,
    DdRowCountBox,
    DdSelectItemsPerPage,
    DdSubHeader,
    DdTextBox
  },
  data: () => ({
    // 条件制御用
    isConditionHide: false,
    // 一覧制御用
    isCsvDownloader: false,
    isXlsDownloader: false,
    // ページネーション用
    itemsPerPage: 0,
    page: 1,
    headers: [
      { text: 'ID', value: 'id', align: ' d-none' },
      { text: '配車表コード', value: 'haishahyoCd', align: 'center', width: '10vw' },
      { text: '配車表表示名', value: 'haishahyoNm' },
      { text: '表示順', value: 'hyojiOrder', align: 'right', width: '8vw' },
      { text: '編集', value: 'haishaSharyoEdit', align: 'center', sortable: false, width: '8vw' },
      { text: '反映', value: 'actions', align: 'center', sortable: false, width: '8vw' },
      { text: '変更状況', value: 'memo', align: 'center', width: '8vw' },
      { text: '削除', value: 'deleteAction', align: 'center', sortable: false, width: '5vw' }
    ],
    conditions: { id: null },
    recHaishaInfo: {},
    invalidMessages: {},
    modeOfEdit: 2,
    modeKengen: 2,
    rec: {},
    rows: [{}],
    mstSharyoHeaders: header.vwCMstSharyoHeaders,
    haishahyoEditDialog: false
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg'
    }),
    filteredRows () {
      return this.rows.map((elem) => {
        elem.hyojiFlgDisp = elem.hyojiFlg ? '表示中' : '非表示'
        elem.memo = elem.editFlg ? '変更中' : ''

        return elem
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    isShoukaiMode () {
      return this.modeOfEdit === 1
    },
    isSaveButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1) {
        return true
      }
      return false
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
    this.fetchData()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        searchText: this.searchText
      }
    },
    /**
     * 全件取得 ※初期表示時のみ
     * @returns
     */
    fetchData: function () {
      console.log('fetchData')
      return new Promise((resolve) => {
        this.HttpClient
          .get('api/v1/MstHaishahyo/GetAll')
          .then((data) => {
            this.rows = data.payload
            this.rows.map((elem) => {
              elem.editFlg = false
              return elem
            })
            this.cloneRows = dolly.clone(this.getCloneTargetMethod())
          })
      })
    },
    /**
     * 更新後の再取得 ※対象行のデータとClone情報を差し替える
     * @param {} recId
     * @param {*} rowIndex
     * @returns
     */
    getData: function (recId, rowIndex) {
      // サマリメッセージ初期化
      // this.clearSummaryMessage()

      return new Promise((resolve) => {
        this.HttpClient
          .get(`/api/v1/MstHaishahyo/find?id=${recId}`)
          .then((data) => {
            this.rec = data.payload
            // 取得データを差し替え
            this.rec.editFlg = false
            this.rec.memo = ''

            Object.assign(this.rows[rowIndex], this.rec)
            // CloneData更新
            this.cloneRows = dolly.clone(this.getCloneTargetMethod())
            // 画面への再描写 ※強制発火用にspliceを実行
            this.rows.splice()
          })
      })
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: [],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          return new Promise(resolve => {
            self.search().then(() => {
              resolve()
            })
          })
        },
        restoreViewPromise: (c) => {
          console.log('MstHaishahyo.restoreViewPromise', c)
          return new Promise(resolve => {
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('MstHaishahyo.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onEditClose: function (e, row) {
      if (e === true) {
        const index = this.rows.indexOf(row.item)
        this.rec = Object.assign({}, row.item)

        // 変更フラグ判定（≠Clone値は変更有とみなす）
        if (this.isChanged(this.rec, this.cloneRows.rows[index])) {
          this.rec.editFlg = true
        } else {
          console.log(this.row)
          this.rec.editFlg = false
        }

        Object.assign(this.rows[index], this.rec)
        // 画面への再描写 ※強制発火用にspliceを実行
        this.rows.splice()
      }
    },
    onEditCloseNum: function (e, row) {
      // /* eslint no-debugger: "warn" */
      // debugger
      if (e === true && isFinite(this.getNullValue(row.value))) {
        const index = this.rows.indexOf(row.item)
        this.rec = Object.assign({}, row.item)

        // 変更フラグ判定（≠Clone値は変更有とみなす）
        if (this.isChanged(this.rec, this.cloneRows.rows[index])) {
          this.rec.editFlg = true
        } else {
          this.rec.editFlg = false
        }

        Object.assign(this.rows[index], this.rec)
        // 画面への再描写 ※強制発火用にspliceを実行
        this.rows.splice()
      }
    },
    onSwitchDisplay: function (item) {
      const index = this.rows.indexOf(item)
      this.rec = Object.assign({}, item)
      this.rec.hyojiFlg = !this.rec.hyojiFlg

      // 変更フラグ判定（≠Clone値は変更有とみなす）
      if (this.isChanged(this.rec, this.cloneRows.rows[index])) {
        this.rec.editFlg = true
      } else {
        this.rec.editFlg = false
      }

      Object.assign(this.rows[index], this.rec)
    },
    onCancel: function (item) {
      // サマリメッセージ初期化
      this.clearSummaryMessage()

      const index = this.rows.indexOf(item)
      this.getData(item.id, index)
    },
    onSave: function (item) {
      if (!item.haishahyoCd) {
        var msgInfo = JSON.parse(JSON.stringify(message.getInfo('COME9001')))
        msgInfo.message = message.get('COME9001', ['配車表マスタ更新', '配車表コードは必須入力です。'])
        this.setSummaryMessage(msgInfo)
        return false
      }
      if (item.haishahyoCd.length > 6) {
        msgInfo = JSON.parse(JSON.stringify(message.getInfo('COME9001')))
        msgInfo.message = message.get('COME9001', ['配車表マスタ更新', '配車表コードは６桁以内で入力して下さい。'])
        this.setSummaryMessage(msgInfo)
        return false
      }
      if (!item.haishahyoNm) {
        msgInfo = JSON.parse(JSON.stringify(message.getInfo('COME9001')))
        msgInfo.message = message.get('COME9001', ['配車表マスタ更新', '配車表表示名は必須入力です。'])
        this.setSummaryMessage(msgInfo)
        return false
      }
      if (item.haishahyoNm.length > 20) {
        msgInfo = JSON.parse(JSON.stringify(message.getInfo('COME9001')))
        msgInfo.message = message.get('COME9001', ['配車表マスタ更新', '配車表表示名は２０桁以内で入力して下さい。'])
        this.setSummaryMessage(msgInfo)
        return false
      }
      if (!item.hyojiOrder) {
        msgInfo = JSON.parse(JSON.stringify(message.getInfo('COME9001')))
        msgInfo.message = message.get('COME9001', ['配車表マスタ更新', '表示順は必須入力です。'])
        this.setSummaryMessage(msgInfo)
        return false
      }
      if (item.hyojiOrder.length > 4) {
        msgInfo = JSON.parse(JSON.stringify(message.getInfo('COME9001')))
        msgInfo.message = message.get('COME9001', ['配車表マスタ更新', '表示順は４桁以内で入力して下さい。'])
        this.setSummaryMessage(msgInfo)
        return false
      }
      if (isNaN(item.hyojiOrder)) {
        msgInfo = JSON.parse(JSON.stringify(message.getInfo('COME9001')))
        msgInfo.message = message.get('COME9001', ['配車表マスタ更新', '表示順は数字で入力して下さい。'])
        this.setSummaryMessage(msgInfo)
        return false
      }
      if (Number(item.hyojiOrder) <= 0) {
        msgInfo = JSON.parse(JSON.stringify(message.getInfo('COME9001')))
        msgInfo.message = message.get('COME9001', ['配車表マスタ更新', '表示順は１以上９９９９以下で入力して下さい。'])
        this.setSummaryMessage(msgInfo)
        return false
      }
      const index = this.rows.indexOf(item)
      var m = 'COMQ0002'
      if (item.haishahyoCd !== this.cloneRows.rows[index].haishahyoCd) {
        m = 'COMQ0008'
      }
      const p = modals.showConfirm
      p(m).then((ok) => {
        if (ok === false || ok === undefined) { return }

        const index = this.rows.indexOf(item)
        this.rec = Object.assign({}, item)

        const self = this
        const opt = {
          registerRequestPromise: self.registerPromise,
          registerResponsePromise: (data) => {
            return new Promise(resolve => {
              // 更新後に自レコードのみ再取得
              this.getData(this.rec.id, index)
              self.Effects.loadComplete()
            })
          },
          getIdMethod: () => {
            return 0
          },
          continuousInputInitializePromise: (id) => {
            return new Promise(resolve => {
              resolve()
            })
          },
          getTransitionBackParams: function () {
            return {
              actionId: 0
            }
          },
          isUpdateModeMethod: function () {
            return true
          },
          isNoRefreshModeMethod: function () {
            return true
          },
          isNoMessageModeMethod: function () {
            return false
          },
          getSavedInputMethod: function () {
            return true
          }
        }
        this.register(opt)
      })
    },
    registerPromise: function () {
      // 更新処理実行
      // 自レコードのみを更新する
      var rtn = this.HttpClient.post('/api/v1/D2mstd0380/UpdateHaishahyo', this.rec)
      return rtn
    },
    // 登録前チェック
    registerValidate: function () {
      return true
    },
    onDelete: function (item) {
      const self = this
      self.rec = Object.assign({}, item)

      const opt = {
        deleteRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/D2mstd0380/DeleteWithRelation', self.rec).then(data => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        getSavedInputMethod: function () {
          return {}
        },
        settingReloadWindow: function () {
          return true
        }
      }
      this.delete(opt)
    },
    deleteValidate: function () {
      return true
    },
    onCsvButtonClick: function (e) {

    },
    // 追加ボタン
    onHaishahyoAddButtonClick: function (e) {
      console.log('追加ボタン')
      this.recHaishaInfo = {}
      this.$set(this.recHaishaInfo, 'hyojiOrder', '9,999')
      this.recHaishaInfo.hyojiFlg = true
      this.$modal.show('haishahyo-edit-dialog')
    },
    // 閉じるボタン
    onHaishahyoCloseButtonClick: function (e) {
      console.log('閉じるボタン')
      this.$modal.hide('haishahyo-edit-dialog')
    },
    onHaishahyoEditSaveButtonClick: function (e) {
      if (!this.recHaishaInfo.haishahyoCd) {
        this.$refs.haishahyoCd[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001', '配車表コード'))
        return
      }
      if (!this.recHaishaInfo.haishahyoNm) {
        this.$refs.haishahyoNm[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001', '配車表表示名'))
        return
      }
      if (!this.recHaishaInfo.hyojiOrder) {
        this.$refs.hyojiOrder[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001', '表示順'))
        return
      }
      const p = modals.showConfirm
      p('COMQ0001').then((ok) => {
        if (ok === false || ok === undefined) { return }
        this.recHaishaInfo.hyojiOrder = this.removeComma(this.recHaishaInfo.hyojiOrder)
        const self = this
        const opt = {
          registerRequestPromise: self.newRegisterPromise,
          registerResponsePromise: (data) => {
            return new Promise(resolve => {
              this.onHaishahyoCloseButtonClick()
              this.fetchData()
              resolve()
            })
          },
          getIdMethod: () => {
            return self.rec.id
          },
          continuousInputInitializePromise: (id) => {
            return new Promise(resolve => {
              resolve()
            })
          },
          getTransitionBackParams: function () {
            return {
              actionId: 0
            }
          },
          isUpdateModeMethod: function () {
            return true
          },
          isNoRefreshModeMethod: function () {
            return true
          },
          isNoMessageModeMethod: function () {
            return false
          },
          getSavedInputMethod: function () {
            return true
          }
        }
        this.register(opt)
      })
    },
    newRegisterPromise: function () {
      // 登録/更新処理実行
      // 自レコードのみを更新する
      var rtn = this.HttpClient.post('/api/v1/MstHaishahyo/Create', this.recHaishaInfo)
      return rtn
    },
    // --------------------------------------------------
    // 共通関数
    // --------------------------------------------------
    setRowColorClass: function (item) {
      return item.editFlg === true ? 'cellBackgroundColorGreen' : ''
    },
    isChanged: function (a, b) {
      if (a.haishahyoCd !== b.haishahyoCd || a.haishahyoNm !== b.haishahyoNm || a.hyojiOrder !== b.hyojiOrder || a.hyojiFlg !== b.hyojiFlg) {
        return true
      } else {
        return false
      }
    },
    // Nullをゼロに変換(カンマ除去も)
    isNullValue (inputValue) {
      if (inputValue === null) { return true }
      if (inputValue === undefined) { return true }
      if (inputValue === '') { return true }
      return false
    },
    // Nullをゼロに変換(カンマ除去も)
    getNullValue (inputValue) {
      if (inputValue === null) { return 0 }
      if (inputValue === undefined) { return 0 }
      if (inputValue === '') { return 0 }
      return this.removeComma(inputValue)
    },
    removeComma: function (num) {
      if (!num) { return }

      if (window.isFinite(num) === true) {
        return num
      }
      var removedNum = num.replace(/,/g, '')
      return removedNum
    },
    // ページ操作
    changeItemsPerPage: function (e) {
      console.log('changeItemsPerPage', e)
      this.itemsPerPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    changePage: function (e) {
      this.page = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    // ダミー
    onDummyFunction: function () {
      this.$emit('dummy')
    }
  }
}
